import { BoardScreen } from "../../features/board";

/** FS-12-01 칠판 뷰(새 창 · 렌더 전용) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/board */
export default function BoardPage() {
  return <BoardScreen />;
}
